
import { Typography, Box, Tooltip, styled } from '@mui/material';

const HeaderRoot = styled(Box)(({ theme }) => ({
  backgroundColor: '#fff',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}));

export default function Header({ title, subtitle }) {
  if (!title) return null;

  const titleEl = (
    <Typography
      variant="body2"
      sx={{
        fontWeight: 700,
        color: '#424242',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        display: 'inline-block',
        fontSize: { xs: '0.875rem', sm: '0.95rem', md: '0.9rem', lg: '0.9rem', xl: '1.1rem' },
        lineHeight: 1.2,
      }}
    >
      {title}
    </Typography>
  );

  return (
    <HeaderRoot>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{
          flex: 1, minWidth: 0, fontSize: {
            xs: '0.875rem', sm: '0.95rem', md: '0.9rem', lg: '0.9rem', xl: '1.1rem'
          }
        }}>
          {subtitle ? (
            <Tooltip title={subtitle} arrow placement="right">
              {titleEl}
            </Tooltip>
          ) : (
            titleEl
          )}
        </Box>
      </Box>
    </HeaderRoot>
  );
}



